const ic_accounting = require("assets/v1.1/icons/Core/Accounting/ic_accounting.svg");

export const Accounting = {
  core: ic_accounting,
};
